import { useAtomValue } from 'jotai';

import { getTimeOfDay } from '../../common/utils/homeUtils';
import { userFirstNameAtom } from '../../user/state/UserAtoms';

export const useGreeting = () => {
    const timeOfDay = getTimeOfDay();
    const userFirstName = useAtomValue(userFirstNameAtom);
    const greeting =
        userFirstName != null
            ? `Good ${timeOfDay}, ${userFirstName}`
            : `Good ${timeOfDay}`;

    return { greeting };
};
